import React from 'react';
import { ArrowRight } from 'lucide-react';
export function RelatedServices() {
  const services = [{
    title: 'Residential Glass',
    copy: 'Broken windows, door glass, custom glass and other residential glass services.',
    link: '/residentialglass.html'
  }, {
    title: 'Window Glass',
    copy: 'Glass-only window replacement, foggy double-pane glass and broken window glass.',
    link: '/windowglass.html'
  }, {
    title: 'Custom Mirrors',
    copy: 'Bathroom mirrors, vanity mirrors, wall mirrors and home gym mirrors.',
    link: '/customglassmirrors.html'
  }, {
    title: 'Glass Deck Railing',
    copy: 'Custom glass railing panels for decks and outdoor views.',
    link: '/deckglass.html'
  }, {
    title: 'Euro Glass Shower Doors',
    copy: 'Dedicated Euro-style frameless shower door details and inspiration.',
    link: '/euroglasshowerdoors.html'
  }];
  return <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-1668">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1669">
        <div className="anim-on-scroll" data-id="element-1670">
          <h2 className="text-2xl font-bold text-navy mb-8 text-center tracking-tight" data-id="element-1671">
            More Custom Glass for Your Home
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-1672">
          {services.map((svc, i) => <a key={i} href={svc.link} className="block bg-white p-5 rounded-xl border border-gray-100 hover:border-primary hover:shadow-md transition-all group h-full scroll-fade-up" style={{
          animationDelay: `${i * 0.05}s`
        }} data-id="element-1673">
              <h3 className="font-bold text-navy mb-2 group-hover:text-primary transition-colors flex items-center justify-between" data-id="element-1674">
                {svc.title}
                <ArrowRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity -translate-x-2 group-hover:translate-x-0" data-id="element-1675" />
              </h3>
              <p className="text-sm text-gray-500" data-id="element-1676">{svc.copy}</p>
            </a>)}
        </div>
      </div>
    </section>;
}